



















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {dispatchGetPackagePaymentUrl} from '@/store/subscription/actions';
import { ICartPayment } from '@/interfaces';
import { StripeCheckout } from '@vue-stripe/vue-stripe';

@Component({
  components: {
    StripeCheckout,
  },
})
export default class PackageCard extends Vue {
  @Prop({default: 'mb-16pt'}) public cardClass!: string;
  @Prop({default: 0}) public id!: number;
  @Prop({default: ''}) public title!: string;
  @Prop({default: ''}) public description!: string;
  @Prop({default: ''}) public duration!: string;
  @Prop({default: 0}) public price!: number;
  @Prop({default: true}) public payDisabled!: boolean;
  @Prop({default: ''}) public buttonTitle!: string;
  
  public loadingSubmit: boolean = false;
  public cartPayment: ICartPayment | null = null;

  public async purchasePackage(id) {
    if (this.payDisabled) {
      return;
    }
    
    this.loadingSubmit = true;
    const response = await dispatchGetPackagePaymentUrl(this.$store, {package: id});
    if (response && response.payment_method === 'stripe') {
      this.cartPayment = response;
      // @ts-ignore
      setTimeout(()=>{this.$refs.checkoutRef.redirectToCheckout();}, 100);
    }
    this.loadingSubmit = false;
    // if (link !== '') {
    //   const element = document.createElement('a');
    //   element.href = link;
    //   setTimeout(() => {
    //     element.click();
    //     }, 200);
    // }

  }
}
